import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import CircleText from '../../svg/w4w-circle-text.svg';
import Drop from '../../svg/w4w-drop.svg';
import CourierIcon from '../../svg/w4w-courier-icon.svg';
import CWCIcon from '../../svg/w4w-cwc-icon.svg';

const renderGraphic = (icon, fill2) => {
  switch (icon) {
    case 'courier':
      return <CourierGraphic fill2={fill2} />;
    case 'cwc':
      return <CWCGraphic />;
    case 'drop':
    default:
      return <DropGraphic />;
  }
};

const DetailGraphic = ({ icon, fill, fill2 }) => (
  <Fragment>
    <Graphic fill={fill} />
    {renderGraphic(icon, fill2)}
  </Fragment>
);

const Graphic = styled(CircleText)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 248px;
  height: 248px;
  fill: ${props => props.fill};

  ${screen.below(bp.mobile, `
    width: 124px;
    height: 124px;
  `)};
`;

const CourierGraphic = styled(CourierIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 70px;
  fill: ${props => props.fill2};

  ${screen.below(bp.mobile, `
    width: 50px;
    height: 35px;
  `)};
`;

const CWCGraphic = styled(CWCIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 105px;
  height: 60px;

  ${screen.below(bp.mobile, `
    width: 60px;
    height: 60px;
    top: 55%;
  `)}
`;

const DropGraphic = styled(Drop)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  fill: ${props => props.theme.blue};

  ${screen.below(bp.mobile, `
    width: 20px;
    height: 20px;
  `)};
`;

DetailGraphic.propTypes = {
  icon: PropTypes.string,
  fill: PropTypes.string,
  fill2: PropTypes.string,
};

DetailGraphic.defaultProps = {
  fill2: '#255566',
};

export default DetailGraphic;
